import {
  actions,
  getPromoCodesLookupsAsync,
  getPromoCodesDatatableAsync,
  createPromoCodeAsync,
  editPromoCodeAsync,
  assignPromoCodeToProductGroupAsync,
  getPromoCodeByIdAsync,
} from './slices';

export const PromoCodesActions = {
  ...actions,
  getPromoCodesLookupsAsync,
  getPromoCodesDatatableAsync,
  createPromoCodeAsync,
  editPromoCodeAsync,
  assignPromoCodeToProductGroupAsync,
  getPromoCodeByIdAsync,
};
